"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Step = void 0;
var React = require("react");
var react_popper_1 = require("react-popper");
var Modal_1 = require("../../../ReactPortalWrapper/Modal");
var Bullet_1 = require("./Bullet");
var Step_styles_1 = require("./Step.styles");
var ToolTip_1 = require("./ToolTip");
var Step = function (_a) {
    var ClientId = _a.ClientId, Title = _a.Title, OptionalText = _a.OptionalText, AriaLabel = _a.AriaLabel, AriaControlsPanel = _a.AriaControlsPanel, Disabled = _a.Disabled, IsCurrent = _a.IsCurrent, IsLink = _a.IsLink, OnClick = _a.OnClick, State = _a.State;
    var _b = React.useState(false), showToolTip = _b[0], setShowToolTip = _b[1];
    var titleSpanRef = React.createRef();
    var optionalSpanRef = React.createRef();
    var checkOverflow = function (element) {
        return element.clientWidth < element.scrollWidth;
    };
    var ToolTipModal = React.useMemo(function () {
        return React.createElement(Modal_1.Modal, null,
            React.createElement(react_popper_1.Popper, { placement: "bottom-start" }, function (_a) {
                var ref = _a.ref, style = _a.style;
                return (React.createElement("div", { ref: ref, style: style },
                    React.createElement(ToolTip_1.ToolTip, null, OptionalText ? Title + ", " + OptionalText : Title)));
            }));
    }, []);
    var handleOnClick = function () {
        OnClick();
    };
    var handleOnMouseOver = function () {
        var isOverflowing = checkOverflow(titleSpanRef.current) || (optionalSpanRef.current !== null && checkOverflow(optionalSpanRef.current));
        setShowToolTip(isOverflowing);
    };
    var handleOnMouseLeave = function () {
        setShowToolTip(false);
    };
    return (React.createElement(react_popper_1.Manager, null,
        React.createElement(react_popper_1.Reference, null, function (_a) {
            var ref = _a.ref;
            return (React.createElement(Step_styles_1.StepButton, { id: ClientId, ref: ref, IsCurrent: IsCurrent, StepState: State, onClick: handleOnClick, onMouseOver: handleOnMouseOver, onMouseLeave: handleOnMouseLeave, IsLink: IsLink, type: "button", tabIndex: IsCurrent ? 0 : -1, role: "tab", "aria-controls": AriaControlsPanel, "aria-label": AriaLabel || Title, "aria-selected": IsCurrent, disabled: Disabled, "data-state": State },
                React.createElement(Bullet_1.Bullet, { IsCurrent: IsCurrent, BulletState: State }),
                React.createElement(Step_styles_1.StepTitleSpan, { IsLink: IsLink, ref: titleSpanRef }, Title),
                OptionalText && React.createElement(Step_styles_1.OptionalTextSpan, { ref: optionalSpanRef }, OptionalText)));
        }),
        showToolTip && ToolTipModal));
};
exports.Step = Step;
